export default {"src":"/_next/static/media/caret.3343cc3d.svg","height":18,"width":10,"blurWidth":0,"blurHeight":0};